import { Utils } from '../utils';
import { CustomUIEvent } from '../events';
//namespace Pacem.UI {
export var RescaleHandle;
(function (RescaleHandle) {
    RescaleHandle["All"] = "all";
    RescaleHandle["Top"] = "top";
    RescaleHandle["Left"] = "left";
    RescaleHandle["Right"] = "right";
    RescaleHandle["Bottom"] = "bottom";
})(RescaleHandle || (RescaleHandle = {}));
export var RescaleEventType;
(function (RescaleEventType) {
    RescaleEventType["Start"] = "rescalestart";
    RescaleEventType["Rescale"] = "rescale";
    RescaleEventType["End"] = "rescaleend";
})(RescaleEventType || (RescaleEventType = {}));
export class RescaleEventArgsClass {
    constructor(_builder) {
        this._builder = _builder;
    }
    get currentPosition() {
        return this._builder.currentPosition;
    }
    get targetRect() {
        return this._builder.targetRect;
    }
    get element() {
        return this._builder.element;
    }
    get handle() {
        return this._builder.handle;
    }
    static fromArgs(builder) {
        return new RescaleEventArgsClass(Utils.extend({}, builder));
    }
}
export class RescaleEvent extends CustomUIEvent {
    constructor(type, args, eventInit, evt) {
        super(type, args, eventInit, evt);
    }
}
//}
